import { render, staticRenderFns } from "./viewAgent.vue?vue&type=template&id=ed434a9a&scoped=true&"
import script from "./viewAgent.vue?vue&type=script&lang=js&"
export * from "./viewAgent.vue?vue&type=script&lang=js&"
import style0 from "./viewAgent.vue?vue&type=style&index=0&id=ed434a9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed434a9a",
  null
  
)

export default component.exports